import { useTranslation } from 'react-i18next'
import { Check } from 'lucide-react'

const languages = [
  { code: 'uz', label: "O'zbekcha", flag: '🇺🇿' },
  { code: 'ru', label: 'Русский', flag: '🇷🇺' },
]

export function LanguageSwitcher() {
  const { i18n } = useTranslation()

  return (
    <div className="flex gap-3">
      {languages.map((lang) => (
        <button
          key={lang.code}
          onClick={() => i18n.changeLanguage(lang.code)}
          className={`flex items-center gap-3 rounded-lg border px-4 py-3 transition-colors ${
            i18n.language === lang.code
              ? 'border-primary bg-primary/5 text-primary'
              : 'border-border hover:border-primary/50 hover:bg-muted'
          }`}
        >
          <span className="text-2xl">{lang.flag}</span>
          <span className="font-medium">{lang.label}</span>
          {i18n.language === lang.code && (
            <Check className="h-4 w-4 ml-2" />
          )}
        </button>
      ))}
    </div>
  )
}
